import { render, staticRenderFns } from "./zhijiao.vue?vue&type=template&id=58ef9a8e&scoped=true"
import script from "./zhijiao.vue?vue&type=script&lang=js"
export * from "./zhijiao.vue?vue&type=script&lang=js"
import style0 from "./zhijiao.vue?vue&type=style&index=0&id=58ef9a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef9a8e",
  null
  
)

export default component.exports